import React from 'react';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import InfoLabel, { InfoLabelModes } from 'UI/components/molecules/InfoLabel';

import { gridValues, useInfoLabelClasses } from './styles';

/**
 * @param {Object} props
 * @param {Array<Object>} props.labels
 * @param {boolean} props.loading
 * @param {boolean} props.isFlexibleGrid
 */
const InfoLabelsGrid = ({ labels, loading, isFlexibleGrid }) => {
  const classes = useInfoLabelClasses();
  const fixedGrid = { ...gridValues };
  const normalizedLabels = Array.isArray(labels) ? labels : [];

  return (
    <Grid container spacing={3}>
      {normalizedLabels.map(items => {
        const itemsConfig = Array.isArray(items) ? items : [items];

        return itemsConfig.map(item => {
          if (!item) return null;

          const { visible = true } = item;

          const defaultLayoutProps = {
            ...fixedGrid,
            ...(item.config || {})
          };

          const safeDescription =
            item.description === undefined || item.description === null ? '' : item.description;

          const safeSecondaryText =
            item.secondaryText == null || item.secondaryText === undefined
              ? ''
              : item.secondaryText;

          const shouldUseFixedClass = !isFlexibleGrid && !item.config;

          return visible ? (
            <React.Fragment key={`${item.title}-${item.description}`}>
              <Grid
                aria-label={`${item.title} container`}
                component="dl"
                item
                role="group"
                className={shouldUseFixedClass ? classes.infoLabel : undefined}
                {...defaultLayoutProps}
                {...item.config}
              >
                <InfoLabel
                  canCopy={item.mode === InfoLabelModes.EXTERNAL_LINK}
                  cropped={false}
                  isLoading={loading}
                  variant="body1"
                  {...item}
                  description={safeDescription}
                  secondaryText={safeSecondaryText}
                >
                  {safeDescription}
                </InfoLabel>
              </Grid>
              {item.shouldAddDivider && <Divider />}
            </React.Fragment>
          ) : null;
        });
      })}
    </Grid>
  );
};

InfoLabelsGrid.defaultProps = {
  labels: [],
  loading: false,
  isFlexibleGrid: false
};

export default InfoLabelsGrid;
